import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import { withStyles } from "@material-ui/core/styles"
import get from "lodash/get"

import { translate, I18nContext } from "react-i18next"

import PageHeader from "./PageHeader"

import { fetchData } from "../store/action"
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser"
import i18n from "../i18n"
import Cookie from "../util/Cookie"
import config from "../Config"

const Container = styled.div`
  background-color: #f1f1f1;
  height: 100%;
  overflow: hidden;
`

const styles = (theme) => ({
  textField: {
    marginBottom: theme.spacing.unit * 2,
  },
})

const Body = styled.div`
  height: calc(100% - 45px);
  overflow-y: scroll;
  border-radius: 4px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.29);
  padding: 0px 3%;
`

const Heading = styled.span`
  color: #90caf9;
`

const Para = styled.span`
  color: #000000;
`

const Text = styled.span`
  font-size: large;
`

class Testimonials extends React.Component {
  state = {
    renderData: "",
  }

  constructor(props) {
    super(props)
  }

  componentWillMount() {
    const { fetchData } = this.props

    console.log("CHECKING Testimonials ")
    let host = window.location.hostname
    let subDomain = host.split(".")[0]
    const locale = Cookie.get("X-Reycreo-Language-Id")
    i18n.changeLanguage(locale || "en")
    console.log("RENDER Testimonials :: ", locale)
  }

  render() {
    //const { classes } = this.props;

    const { data } = this.props
    const { t } = this.props

    //const Data = get(data, "data");
    //let itr = this.props.data;
    console.log(
      "RENDER Testimonials :: ",
      this.state.renderData.content,
      "  ::  "
    )

    return (
      <Container className='montserratLight'>
        <PageHeader
          backLocation='/play/'
          label={i18n.t("bidnWinTestimonials")}
        />
        <Body>
          <img
            style={{ marginLeft: 0, height: "170%", width: "auto" }}
            src={`${config.BIDNWIN_S3_IMAGE_URL}/Bidnwin5_Testimonials.png`}
            alt='testimonials'
          />
        </Body>
      </Container>
    )
  }
}

Testimonials = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data["tnc"]) {
      mapStateToProps.data = state.data["tnc"]
    }
    return mapStateToProps
  },
  {
    fetchData,
  }
)(withStyles(styles)(Testimonials))

export default translate("translations")(Testimonials)



// WEBPACK FOOTER //
// ./src/views/Testimonials.js